<template>
  <v-container fluid>
    <!-- <base-page-title title="Dashboard Inicial"></base-page-title> -->
    <base-home></base-home>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
    BaseHome: () => import('../components/homepage/BaseHome'),
  },
  computed: {
    // profile_roles(){
    //   if(this.profile?.employee?.role) return true
    //   return false
    // },
    ...mapState({
      // profile: state=>state.User.oneUser,
      // data: state=> state.Module.state_var
    })
  },
}
</script>
